<template>
  <div>
    <div class="panel" v-if="records.length > 0">
      <div class="panel-body">
        <el-timeline class="pl-0">
          <el-timeline-item
            v-for="(record, index) in records"
            :key="index"
            :timestamp="$time(record.created_at).format('YYYY-MM-DD HH:mm')"
            placement="top"
          >
            <el-card>
              <div class="font-bold">
                {{ record.user_name || '系统' }}
                {{ categories[record.category] }}
              </div>
              <div class="mt-10" v-if="record.params">
                <div v-for="(v, k) in JSON.parse(record.params)">
                  {{ k }}：{{ v }}·
                </div>
              </div>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
    <p v-else class="text-center mt-20">无库存信息。</p>
  </div>
</template>

<script>
import { drillStockInfo } from '@/service/getData'

const Categories = {
  1: '入库',
  2: '出库',
}
export default {
  props: {
    serialNumber: String,
  },
  data() {
    return {
      categories: Categories,
      records: [],
    }
  },
  watch: {
    serialNumber() {
      this.getData()
    },
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await drillStockInfo(this.serialNumber)
      if (res.status == 0) {
        this.records = res.data.list
      }
    },
  },
}
</script>

<style scoped>
.font-bold {
  font-weight: bold;
}
.pl-0 {
  padding-left: 0;
}
</style>